<template>
  <div class="no-analysis">
    <img class="no-analysis__icon" src="~/assets/imgs/envelop.webp" alt="envelop" loading="lazy" />
    <div class="no-analysis__container">
      <p class="no-analysis__text">
        Nous ne disposons pas d’analyse à date.
      <br/>Vous êtes investisseur immobilier ou fin connaisseur de {{cityName}} ?
      </p>
      <a :href="analysisLink">
        <uikit-button type="primary">
          Partager mon analyse
        </uikit-button>
      </a>
    </div>
  </div>
</template>

<script>
import { LEGACY_URLS } from '@/helpers/redirect'
import { UikitButton } from '@hz/ui-kit'

export default {
  components: {
    UikitButton
  },
  props: {
    city: {
      type: Object,
      required: true
    },
    cityName: {
      type: String,
      required: true
    }
  },
  computed: {
    analysisLink() {
      return this.$config.public.rlBaseUrl + LEGACY_URLS.RL_INFORMATION_ANALYSIS
    },
  },
}
</script>

<style lang="less" scoped>
.no-analysis {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f4f7fb;
  border: 2px solid #ffffff;
  border-radius: 5px;
  padding: 5px 20px 20px !important;
  margin-top: 20px;

  .no-analysis__icon {
    width: 63px;
  }

  .no-analysis__text {
    text-align: center;
  }

  &__container {
    text-align: center;
  }

  @media @bp-desktop {
    margin-top: 70px;
    padding: 45px 20px 20px !important;
    .no-analysis__icon {
      position: absolute;
      width: 77px;
      top: -61px;
      left: 47%;
    }
  }
}
</style>
